import axios from 'axios';
import { authHeader } from '../_helpers'
export const dashboardService = {
    getAllWebhooks,
    newWebhook,
    getAllProjects,
    deleteWebhook
}
const baseUrl = ``
function getAllWebhooks() {
    return axios({
        method: 'get',
        headers: authHeader(),
        url: `${baseUrl}/v1/webhooks`
    }).then(handleResponse).catch(err => {
        console.log(err.response)
        return Promise.reject(err)
    })
}

function newWebhook(webhook) {
    return axios({
        method: 'post',
        headers: authHeader(),
        url: `${baseUrl}/v1/webhooks`,
        responseType: 'json',
        data: webhook
    }).then(handleResponse, handleError)
}

function getAllProjects() {
    return axios({
        method: 'get',
        headers: authHeader(),
        url: `${baseUrl}/v1/projects`,
        responseType: 'json'
    }).then(handleResponse, handleError)
}

function deleteWebhook(webhookId) {
    return axios({
        method: 'delete',
        headers: authHeader(),
        url: `${baseUrl}/v1/webhooks/${webhookId}`,
        responseType: 'json',
    }).then(handleResponse, handleError)
}
function handleResponse(response) {
    const data = response.data
    if (response.status < 200 && response.status > 299) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            location.reload(true);
        }

        const error = data || response.statusText;
        return Promise.reject(error);
    }
    return data;
}

function handleError(error) {
    if (error.response) {
        if (error.response.status === 401){
            location.reload(true)
        }
    }
    return Promise.reject(error)

}
